module.exports = __webpack_public_path__ + "img/unfinished.698793c8.svg";